import React from 'react';
import { useDS5Controller } from '../hooks/useDS5Controller';
import './SerialScanner.css';

const SerialScanner = () => {
  const {
    serialNumber,
    isConnected,
    error,
    isLoading,
    isWebHIDSupported
  } = useDS5Controller();

  return (
    <div className="scanner-container">
      <div className="scanner-card">

        <div className="scanner-header">
          <h2>Scanner Série</h2>
        </div>

        {!isConnected && (
          <div className="disconnected">
            <h3> 🔌Plug in your DualSense controller.</h3>
            {isLoading && <div className="spinner"></div>}
            {error && <div className="error">Erreur: {error}</div>}
          </div>
        )}

        {isConnected && (
          <div className="serial-display">
            <label>Numéro de Série:</label>
            <div className="serial-value">{serialNumber}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SerialScanner;